export interface BlogMeta {
  icon: string
  text: string
}

export interface BlogMetasProps {
  metas: BlogMeta[]
  /**
   * The grid blog cards carry `font-normal text-[14px] text-etGray` on the meta text.
   * These match no rule in this stylesheet and are inert, but they are part of the
   * established DOM contract — removing them is a visual-risk change, not a cleanup.
   * The list layout and the article header use the bare `text` class instead.
   */
  withLegacyTextClasses?: boolean
}

/**
 * The `.ul-blog-infos` author/category row.
 *
 * Extracted because it appears in both `BlogCard` and the article header on
 * `blog-details`, which would otherwise be two copies of the same markup.
 */
export function BlogMetas({ metas, withLegacyTextClasses = false }: BlogMetasProps) {
  return (
    <div className="ul-blog-infos">
      {metas.map((meta) => (
        <div className="ul-blog-info" key={meta.text}>
          <span className="icon">
            <i className={`flaticon-${meta.icon}`} />
          </span>
          <span className={withLegacyTextClasses ? 'text font-normal text-[14px] text-etGray' : 'text'}>
            {meta.text}
          </span>
        </div>
      ))}
    </div>
  )
}
